import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ChatJSLineChart } from "../../../../Constant";
import { Line } from "react-chartjs-2";
import { LINE_CHART_DATA, LINE_CHART_OPTION } from "../../../../Data/Charts/ChartJS";

const LineChart = () => {
  return (
    <Col xl="6" ms="12" className="box-col-6">
      <Card>
        <CommonCardHeader title={ChatJSLineChart} />
        <CardBody className="chart-block">
          <Line id="myLineCharts" data={LINE_CHART_DATA} options={LINE_CHART_OPTION} width={778} height={400} />
        </CardBody>
      </Card>
    </Col>
  );
};

export default LineChart;
